import Dropdown from "@/lib/Dropdown";
import Menu from "@/lib/Menu";
import { ReactNode } from "react";

export default function SelectUnit({
  value,
  options = [],
  onSelect,
  dunit = false,
  disabled = false,
  width,
}: {
  value: string;
  options: { label: ReactNode; value: string }[];
  onSelect: (value: string) => void;
  dunit?: boolean;
  disabled?: boolean;
  width?: number;
}) {
  return (
    <div style={{ width }}>
      <Dropdown
        disabled={disabled}
        trigger={
          <div
            className={`${!disabled && "cursor-pointer hover:bg-slate-100"} px-0.5 rounded-sm`}
          >
            {dunit && "/"}
            {options.find((o) => o.value === value)?.label}
          </div>
        }
      >
        <Menu
          className="text-gray-800"
          itemGroups={[
            options.map(({ label, value }) => ({
              label,
              click: () => onSelect(value),
            })),
          ]}
        />
      </Dropdown>
    </div>
  );
}
